import { serializeRecordingError } from "./recordingErrors";
import { rollbar } from "providers/rollbar";

// Errors frequently bubble through several layers (e.g. a chunk upload failure
// is reported by the upload hook and then re-thrown into the start/resume
// handler). We de-duplicate by identity so a single underlying failure produces
// exactly one Rollbar event, regardless of how many layers observe it.
const reportedErrors = new WeakSet<object>();

type ReportContext = Record<string, unknown>;

// Reports a recording error to Rollbar with rich, queryable context.
//
// The raw Error is passed as Rollbar's second positional argument so Rollbar
// captures the real stack trace and can fingerprint/group events natively; the
// serialized classification (category, retriability, firebase/HTTP status) is
// attached as custom data alongside any caller-supplied context.
const reportRecordingError = (
  message: string,
  error: unknown,
  context: ReportContext = {}
): void => {
  if (typeof error === "object" && error !== null) {
    if (reportedErrors.has(error)) {
      return;
    }
    reportedErrors.add(error);
  }

  const payload = { ...context, ...serializeRecordingError(error) };

  if (error instanceof Error) {
    rollbar.error(message, error, payload);
  } else {
    rollbar.error(message, payload);
  }
};

export { reportRecordingError };
